import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import RoundedSelect from '@deltek/specification-client/core/Forms/RoundedSelect'
import { PopoverProps } from '@material-ui/core/Popover'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import AddNewProductModal from '../AddProductDialog/AddNewProductModal'

const useStyles = makeStyles((theme: Theme) => ({
    buttonContainers: {
        width: 'max-content',
        display: 'inline-flex',
    },
    buttonItem: {
        display: 'inline-block',
    },
    spaced: {
        marginRight: theme.spacing(1),
    },
}))
// value is also the route to the pages
const selectOptions = [
    {
        display: 'My Company Page',
        value: 'company',
    },
    {
        display: 'Product Listings',
        value: 'all',
    },
    {
        display: 'Submissions',
        value: 'submissions',
    },
]

export interface ProductHeaderProps {
    firmId?: string
    /**
     * Callback for when Edit Mode button is clicked.
     */
    onEditModeClick?: () => void

    /**
     * Shows/hides View navigation.
     */
    showViewNav?: boolean

    /**
     * Shows/hides Edit Mode button
     */
    showEditModeButton?: boolean
    /**
     * Shows/hides AddProduct  button
     */
    showAddProductButton?: boolean

    /**
     * Determines currently selected item in View nav.
     */
    selectValue?: any

    /**
     * Determines load state.
     */
    loading?: boolean

    /**
     * Shows/hides comapny page button
     */
    showCompanyButton?: boolean

    roles?: {
        isDeltekUser?: boolean
        isDeltekAdmin?: boolean
        isDeltekPublishingAuthor?: boolean
        isDeltekAuthor?: boolean
        isBPMAdmin?: boolean
        isBPMAuthor?: boolean
    }
}

const ProductHeader: React.FC<ProductHeaderProps> = ({
    firmId,
    onEditModeClick,
    showEditModeButton,
    showViewNav,
    showCompanyButton,
    showAddProductButton,
    loading = true,
    selectValue = '',
    roles,
}) => {
    const classes = useStyles()
    const history = useHistory()
    const location = useLocation()

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        let defaultPath = `/bpm/products/${event.target.value}`
        if (event.target.value === 'all')
            defaultPath = `/bpm/products/${event.target.value}${location.search}`
        history.push(defaultPath)
    }
    const handleCompanyRoute = (
        _event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        history.push(`/bpm/products/company/${firmId}`)
    }

    const viewBtnRef = useRef<HTMLDivElement>(null)
    const [btnRef, setBtnRef] = useState<HTMLDivElement>()
    const menuProps: Partial<PopoverProps> = {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
        anchorEl: btnRef,
        getContentAnchorEl: null,
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        },
    }
    useEffect(() => {
        viewBtnRef && setBtnRef(viewBtnRef.current as HTMLDivElement)
    }, [viewBtnRef])

    return (
        <div className={classes.buttonContainers}>
            {showViewNav && (
                <div
                    className={clsx(classes.buttonItem, {
                        [classes.spaced]: showEditModeButton,
                    })}
                    ref={viewBtnRef}
                >
                    <RoundedSelect
                        value={selectValue}
                        options={selectOptions.filter(
                            (navItem) =>
                                !location.pathname.includes(navItem.value)
                        )}
                        handleChange={handleChange}
                        renderOptionValue={false}
                        renderValue="View"
                        menuProps={menuProps}
                    />
                </div>
            )}

            {showEditModeButton && (
                <div className={clsx(classes.buttonItem)}>
                    <RoundButton
                        hasShadow={false}
                        loading={loading}
                        data-testid="editModeButton"
                        backgroundColor="#0098D6"
                        onClick={onEditModeClick}
                    >
                        Edit Mode
                    </RoundButton>
                </div>
            )}
            {showCompanyButton && (
                <div
                    className={clsx(classes.buttonItem, {
                        [classes.spaced]: showEditModeButton,
                    })}
                    ref={viewBtnRef}
                >
                    <RoundButton
                        hasShadow={false}
                        loading={loading}
                        data-testid="MyCompanyPage"
                        backgroundColor="#0098D6"
                        onClick={handleCompanyRoute}
                    >
                        My Company Page
                    </RoundButton>
                </div>
            )}

            {showAddProductButton && <AddNewProductModal firmId={firmId} />}
        </div>
    )
}

export default ProductHeader
